// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-layouts-site-js": () => import("./../../../src/layouts/site.js" /* webpackChunkName: "component---src-layouts-site-js" */)
}

